module.exports = __webpack_public_path__ + "img/bilbao.0efa3842.jpg";